<script lang="ts">
	import { getCatalogueCategoryPath } from "@core/schema/paths/getCatalogueCategoryPath.js";
	import { getCataloguePath } from "@core/schema/paths/getCataloguePath.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";
	import type { ProductProps } from "../../templates/ProductProps.js";
	import catalogueTranslations from "../../templates/default.translations.json" with { type: "json" };
	import { getTranslate } from "../../utils/getTranslate.js";
	import Link from "../common/Link.svelte";

	const {
		product,
	}: {
		product: ProductProps["product"];
	} = $props();
	const { tenant } = getGlobalTemplateProps();
	const translate = getTranslate(catalogueTranslations);
</script>

<nav class="text-xs tracking-[2%] text-zms-optical-black">
	<Link href={getCataloguePath(tenant.locale)} class="hover:text-zms-blue font-semibold">
		{translate("buttonText")}
	</Link>
	{#if product.parentProductCategory}
		<span class="mx-1">/</span>
		<Link
			href={getCatalogueCategoryPath(tenant.locale, product.parentProductCategory)}
			class="hover:text-zms-blue font-semibold"
		>
			{product.parentProductCategory}
		</Link>
	{/if}
	<span class="mx-1">/</span>
	<span class="text-gray-900 font-normal">{product.name}</span>
</nav>
